// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export default {
  // Example to change the background color of the AppBar:
  // root: {
  //   backgroundColor: '#000000',
  // },
};
